import { IPaginatedResponse, IResponse, ISearchRequest } from "..";
import client from "../client";

export interface IUserResponse {
  id: string;
  email: string;
  authProviderId: string;
  password: string;

  firstname: string;
  lastname: string;

  role: string;

  verified: boolean;
  deactivated: boolean;
  onboarded: boolean;

  avatar: string;

  createdAt: string;
  updatedOn: string;
}

interface IUserUpdate {
  firstname?: string;
  lastname?: string;
  email?: string;
  onboarded?: boolean;
}

export interface IUserInsight {
  id: string;
  userId: string;
  type: string;
  createdAt: string;
  insight: any;
}

async function getMyUser() {
  return client.get<IResponse<IUserResponse>>("/user/me");
}

async function updateUser(userId: string, user: IUserUpdate) {
  return client.patch<IResponse<IUserResponse>>(`/user/${userId}`, user);
}

async function addUserInsight(userId: string, insights: any) {
  return client.put<IResponse<IUserResponse>>(
    `/user/${userId}/insight`,
    insights
  );
}

async function getUsers() {
  return client.get<IResponse<IUserResponse[]>>("/user");
}

async function searchUsers(req: ISearchRequest) {
  return client.post<IPaginatedResponse<IUserResponse[]>>("/user/search", req);
}

async function getUser(userId: string) {
  return client.get<IResponse<IUserResponse>>(`/user/${userId}`);
}

async function getUserInsight(userId: string, type: string) {
  return client.get<IResponse<IUserInsight>>(`/user/${userId}/insight/${type}`);
}

async function getUserInsights(userId: string) {
  return client.get<IResponse<IUserInsight[]>>(`/user/${userId}/insight`);
}

const api = {
  getMyUser,
  updateUser,
  addUserInsight,
  getUser,
  getUsers,
  getUserInsight,
  searchUsers,
  getUserInsights,
};

export default api;
